import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
const PERMS = {
  manager: ["customers:export", "customers:archive", "products:write", "payments:read", "payments:write", "audit:read", "privacy:read"],
  staff: [],
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try { const r = await api.post("/auth/refresh"); setUser(r.data); } catch { setUser(false); }
    });
    const onExpire = () => setUser(false);
    window.addEventListener("auth:expired", onExpire);
    return () => window.removeEventListener("auth:expired", onExpire);
  }, []);
  const login = async (email, password) => { const r = await api.post("/auth/login", { email, password }); setUser(r.data); return r.data; };
  const logout = async () => { try { await api.post("/auth/logout"); } finally { setUser(false); } };
  const can = (perm) => !!user && (user.role === "admin" || (PERMS[user.role] || []).includes(perm));
  return <Ctx.Provider value={{ user, login, logout, can }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
